import PageLayer from "@/Layouts/views/PageLayer";
import SalesPerformanceReportFormatsLayer from "../../components/SalesPerformanceReportFormats/SalesPerformanceReportFormatsLayer";
import SalesPerformanceRF from "@/assets/icons/settings/SalesPerformanceReportFormats.svg";

export default function SalesPerformanceReportFormats() {
	return (
		<PageLayer title={"Sales Performance Report Formats"} icon={SalesPerformanceRF}>
			<SalesPerformanceReportFormatsLayer />
		</PageLayer>
	);
}
